import React, { useState } from "react";
import RequestService from "../../../services/request.service";

// import { useNavigate } from "react-router"
// import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import { toast } from 'react-toastify'


import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';


import moment from 'moment'


import Dialog from '../../../services/Dialogs'
import { Button, Modal } from 'react-bootstrap'


import { SERVER_ } from  '../../../config';


const REG_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
const REG_NOMBRES = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u

const curp2date = (curp:any) => {
  var m = curp.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ );
  //miFecha = new Date(año,mes,dia) 
  var anyo = parseInt(m[1],10)+1900;
  if( anyo < 1950 ) anyo += 100;
  var mes = parseInt(m[2], 10)-1;
  var dia = parseInt(m[3], 10);
  return moment(new Date( anyo, mes, dia )).format('YYYY-MM-DD');
}

const ModalNuevoGerente = ( props ) => {

  const dialog = new Dialog();


  const { show, onHide } = props


var mensaes_validacion_generico = 'Este campo es obligatorio'


const schema = yup.object().shape({


  // # id, uuid, activo, 
  username: yup.string().required(mensaes_validacion_generico).matches(/^[a-zA-Z0-9]+$/,'La contraseña solo puede tener letras y números. No se aceptan espacios ni caracteres especiales'),
  pwd: yup .string().required('La contraseña es obligatoria') .matches( /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, "Debe contener 8 carácteres, 1 mayúscula, 1 minúscula, 1 número y un caracter especial como: * ! % $ & " ),
    changepassword: yup.string().required().when("pwd", {
      is: val => (val && val.length > 0 ? true : false),
      then: yup.string().oneOf(
        [yup.ref("pwd")],
        "Las contraseñas NO coinciden"
      )
    }),
  curp: yup.string().required(mensaes_validacion_generico).matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),
  email: yup.string().required(mensaes_validacion_generico).email('Formato de Email no valido').required('Este campo es obligatorio'),
  celular: yup.string().required(mensaes_validacion_generico).matches(/^\d{10}$/,"Formato no valido"),

  nombres: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required(mensaes_validacion_generico),
  paterno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required(mensaes_validacion_generico),
  materno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido"),

  direccion: yup.string().required( mensaes_validacion_generico ),

  uuid_sucursal: yup.string().required( mensaes_validacion_generico ),
  rol: yup.string().required(mensaes_validacion_generico),
  fecha_ingreso: yup.string().required(mensaes_validacion_generico),
  // idgerente: yup.string().required(mensaes_validacion_generico),

  terms: yup.bool().required().oneOf([true], 'Los terminos y condiciones deben ser aceptadas'),
});


  const [ sucursales, setSucursales] = useState<any>([])

  const cargarGerentes = async() => {

    try{
      let res = await RequestService.getEndPoint('sucursales')
      // console.log(res.data)
      setSucursales(res.data)
    }
    catch(e){
      toast.error('Tuvimos problemas al cargar la lista de Gerentes')
    }

  }


  React.useEffect(() => {
    cargarGerentes()
  }, []);

const enviarFormulario = async (nuevo_usuario:any,event:any,) =>{
  // console.log('??')
  try{
      await dialog.open({
        accept: 'Crear Usuario',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
        // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
        target: event.target,
        template: `
          <dl>
            <dt>Nombre</dt>
            <dd>`+nuevo_usuario.nombres+` `+nuevo_usuario.paterno+` `+nuevo_usuario.materno+`</dd>
            <dt>CURP</dt>
            <dd>`+nuevo_usuario.curp+`</dd>
            <dt>Celular</dt>
            <dd>`+nuevo_usuario.celular+`</dd>
            <dt>Correo Electrónico</dt>
            <dd>`+nuevo_usuario.email+`</dd>
          </dl>
        `
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        setSeEnvio(true)
      console.log('lo que se envia es:', nuevo_usuario)
        let res_nuevo_usuario = await RequestService.create('registro/crear_gerente', nuevo_usuario)

        if(res_nuevo_usuario){
          toast.success('Tu registro se realizo correctamente, ahora puede acceder a la plataforma Gesti+ CRM')
          setTimeout(()=>{
            onHide()
          },0)
        }
        else{
          toast.error('Error al crear usuario en el servidor')
        }  
        
      }
    }
    catch(e:any){
      toast.error(e.response.data)
    }
     
}

const [ envio_server, setSeEnvio ] = useState<boolean>(false)



	return (
		<>

      <Modal show={show} size="lg" backdrop="static" onHide={onHide} animation={true}>

        <Modal.Header closeButton>
          <Modal.Title>
          	<small>Nuevo Usuario Gerente / Asistente</small>
          </Modal.Title>
        </Modal.Header>


        <Modal.Body>




    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

      username:  "",

      pwd:  "",
      changepassword:  "",

      celular:  "",
      email:  "",

      curp:  "",
      nombres:  "",
      paterno:  "",
      materno:  "",

      uuid_sucursal:  "",
      
      direccion:  "",


      fecha_ingreso:  new Date() ,

      rol:  "",
      // idgerente:  "",

        // firstName: 'Mark',
        // lastName: 'Otto',
        // username: '',
        // city: '',
        // state: '',
        // zip: '',
        terms: false,
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>

        

          <h5>Información Personal</h5>

          <Row >

            <Form.Group as={Col} md="4" className="mb-3" controlId="nombres">
              <Form.Label>Nombre(s)</Form.Label>
              <Form.Control
                type="text"
                required
                name="nombres"
                value={values.nombres}
                onChange={(e)=>{ setFieldValue('nombres', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.nombres}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.nombres} </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4" className="mb-3" controlId="paterno">
              <Form.Label>Apellido Paterno</Form.Label>
              <Form.Control
                type="text"
                required
                name="paterno"
                value={values.paterno}
                onChange={(e)=>{ setFieldValue('paterno', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.paterno}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.paterno} </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4" className="mb-3" controlId="materno">
              <Form.Label>Apellido Materno</Form.Label>
              <Form.Control
                type="text"
                name="materno"
                value={values.materno}
                onChange={(e)=>{ setFieldValue('materno', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.materno}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.materno} </Form.Control.Feedback>
            </Form.Group>

          </Row>



          <Row >

            <Form.Group as={Col} md="6" className="mb-3" controlId="curp">
              <Form.Label>CURP </Form.Label>
              <Form.Control
                type="text"
                required
                name="curp"
                value={values.curp}
                onChange={(e)=>{ setFieldValue('curp', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.curp}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.curp  } </Form.Control.Feedback>
            </Form.Group>


            <Col md="3">
              { 
                REG_CURP.test(values.curp) &&(
              <div className="mb-3">
                <label className="form-label">Sexo</label>
                <input type="text" readOnly value={values.curp.substr(10,1)==='H'?'HOMBRE':'MUJER'} className="form-control" />
              </div>
                )
              }
            </Col>
            <Col md="3">
              { 
                REG_CURP.test(values.curp) &&(
              <div className="mb-3">
                <label className="form-label">Fecha de Nacimiento</label>
                <input type="text" readOnly value={curp2date(values.curp)} className="form-control" />
              </div>
                )
              }
            </Col>

          </Row>


          <hr/>


          <h5>Información de Contacto</h5>



            <Form.Group  className="mb-3" controlId="direccion">
              <Form.Label>Dirección Completa</Form.Label>
              <Form.Control
                as="textarea"
                type="text"
                required
                name="direccion"
                value={values.direccion}
                onChange={(e)=>{ setFieldValue('direccion', e.target.value.toUpperCase() ) }}
                isInvalid={!!errors.direccion}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.direccion} </Form.Control.Feedback>
            </Form.Group>



          <Row>

            <Form.Group as={Col} md="7" className="mb-3" controlId="email">
              <Form.Label>Correo Electrónico</Form.Label>
              <Form.Control
                type="email"
                required
                name="email"
                value={values.email}
                onChange={(e)=>{ setFieldValue('email', e.target.value ) }}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.email} </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="5" className="mb-3" controlId="celular">
              <Form.Label>Celular</Form.Label>
              <Form.Control
                type="text"
                required
                name="celular"
                value={values.celular}
                onChange={(e)=>{ setFieldValue('celular',e.target.value) }}
                isInvalid={!!errors.celular}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.celular} </Form.Control.Feedback>
            </Form.Group>

          </Row>


          <hr/>

          <h5>Información de Usuario</h5>



          <Row>

            <Form.Group as={Col} md="4" className="mb-3" controlId="username">
              <Form.Label>Nombre de Usuario</Form.Label>
              <Form.Control
                type="text"
                required
                name="username"
                value={values.username}
                onChange={(e)=>{ setFieldValue('username', e.target.value ) }}
                isInvalid={!!errors.username}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.username} </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4" className="mb-3" controlId="pwd">
              <Form.Label>Contraseña para el acceso</Form.Label>
              <Form.Control
                type="password"
                required
                name="pwd"
                value={values.pwd}
                onChange={(e)=>{ setFieldValue('pwd',e.target.value) }}
                isInvalid={!!errors.pwd}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.pwd} </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4" className="mb-3" controlId="changepassword">
              <Form.Label>Confirma tú contraseña</Form.Label>
              <Form.Control
                type="password"
                required
                name="changepassword"
                value={values.changepassword}
                onChange={(e)=>{ setFieldValue('changepassword',e.target.value) }}
                isInvalid={!!errors.changepassword}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.changepassword} </Form.Control.Feedback>
            </Form.Group>



          </Row>


          <Row>
            <Col md="6">
              <div className="mb-3">
                <label className="form-label">Sucursal</label>
                  <Form.Select aria-label="Selección de Sucursal" required value={values.uuid_sucursal} onChange={(e)=>{ setFieldValue('uuid_sucursal',e.target.value) }} isInvalid={!!errors.uuid_sucursal} >
                    <option>Selecciona una sucursal</option>
                    { sucursales.map((sucursal:any)=><option value={sucursal.uuid}>{sucursal.nombre_sucursal}</option>)}

                  </Form.Select>
                  <Form.Control.Feedback type="invalid"> {errors.uuid_sucursal} </Form.Control.Feedback>
              </div>
            </Col>
            <Col md="6">
              <Form.Label>Fecha de Ingreso</Form.Label>
              <DatePicker selected={values.fecha_ingreso} className="form-control" onChange={(date) => setFieldValue('fecha_ingreso', date ) } dateFormat="yyyy-MMMM-dd"  />
            </Col>
          </Row>



          <Row>

              <div className="mb-3">
                <label className="form-label">TIPO DE USUARIO</label>
                  <Form.Select aria-label="Selección de Gerente / Asistente" required value={values.rol} onChange={(e)=>{ setFieldValue('rol',e.target.value) }} isInvalid={!!errors.rol} >
                    <option>Selecciona un tipo de Usuario</option>
                    <option value={'ROLE_GERENTE_JR'}>GERENTE JUNIOR</option>
                    <option value={'ROLE_GERENTE'}>GERENTE</option>
                    <option value={'ROLE_ASISTENTE'}>ASISTENTE</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid"> {errors.rol} </Form.Control.Feedback>
              </div>

          </Row>




          <br/>

          <Form.Group className="mb-3">
            <Form.Check
              required
              name="terms"
              label="Acepto los terminos y condiciones"
              onChange={handleChange}
              isInvalid={!!errors.terms}
              feedback={errors.terms}
              feedbackType="invalid"
              id="validationFormik0"
            />
          </Form.Group>

          {
             // JSON.stringify(values)
          }
 
                <Button className="btn-lg" type="submit">Guardar Cambios</Button>


          
        </Form>
      )}
    </Formik>



        </Modal.Body>



      </Modal>

		</>
	)

}



export default ModalNuevoGerente